module.exports = __webpack_public_path__ + "static/assets/26add8d06fefebf31d5525168e6e51f4.png";